<!-- Size Detector -->
<app-size-detector></app-size-detector>
<!-- UI Tour -->
<zx-ui-tour></zx-ui-tour>
<!-- Main App Loader -->
@if (isAppLoading) {
    <div class="app-loading">
        <div class="logo">
            <!-- <img width="200" alt="Zixi logo" src="assets/images/zixi-white.png" /> Note: logo removed due to white labeling feature -->
        </div>
        <div class="dots-loader"></div>
    </div>
}
<!-- Content Area -->
@if (!isAppLoading) {
    <main class="flex-container" [ngClass]="{ dark: isDarkMode }">
        <!-- Topbar -->
        @if (isLoggedIn$ | async) {
            <app-topbar class="d-print-none"></app-topbar>
        }
        <div class="content-container">
            <!-- Navigation -->
            @if ((isLoggedIn$ | async) && navigationVisible) {
                <app-navigation #navigation></app-navigation>
            }
            <!-- Content -->
            <ng-content>
                <!-- Notifying  Message -->
                @if (errorInGetUserRequest$ | async; as error) {
                    <app-notifying-message [message]="error"></app-notifying-message>
                }
                <!-- Content Loader -->
                @if (isLoadingRoute | async) {
                    <div class="content-loading">
                        <div class="dots-loader">
                            <span class="sr-only">{{ "LOADING" | translate }}...</span>
                        </div>
                    </div>
                }
                <div class="d-flex flex-1 flex-column overflow-auto" [ngClass]="{ 'd-none': isLoadingRoute | async }">
                    <!-- Critical Announcements -->
                    @if (isLoggedIn$ | async) {
                        <app-critical-announcements></app-critical-announcements>
                    }
                    <!-- Router Outlet -->
                    <div id="outlet-container" class="outlet-container">
                        <router-outlet #routerOutlet="outlet"></router-outlet>
                    </div>
                </div>
            </ng-content>
        </div>
    </main>
}
